import { Button, MenuItem, Select } from "@mui/material";
import NumberSelector from "../entity-management/entity-selectors/number-selector";

interface FiltersSectionProps {
  readonly selectedBowlType: "seam" | "all spin" | "wrist spin" | "finger spin" | "all";
  readonly setSelectedBowlType: (type: FiltersSectionProps["selectedBowlType"]) => void;
  readonly selectedInnings: "both" | "first" | "second";
  readonly setSelectedInnings: (innings: FiltersSectionProps["selectedInnings"]) => void;
  readonly overRange: { start: number; end: number };
  readonly setOverRange: (range: { start: number; end: number }) => void;
  readonly mergeYears: boolean;
  readonly setMergeYears: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function FiltersSection({
  selectedBowlType,
  setSelectedBowlType,
  selectedInnings,
  setSelectedInnings,
  overRange,
  setOverRange,
  mergeYears,
  setMergeYears,
}: FiltersSectionProps) {
  return (
    <>
      <Select
        value={selectedBowlType}
        onChange={(e) =>
          setSelectedBowlType(
            e.target.value as FiltersSectionProps["selectedBowlType"]
          )
        }
      >
        <MenuItem value="seam">Seam</MenuItem>
        <MenuItem value="all spin">All Spin</MenuItem>
        <MenuItem value="wrist spin">Wrist Spin</MenuItem>
        <MenuItem value="finger spin">Finger Spin</MenuItem>
        <MenuItem value="all">All</MenuItem>
      </Select>

      <Select
        value={selectedInnings}
        onChange={(e) =>
          setSelectedInnings(
            e.target.value as FiltersSectionProps["selectedInnings"]
          )
        }
      >
        <MenuItem value="both">Both Innings</MenuItem>
        <MenuItem value="first">First Innings</MenuItem>
        <MenuItem value="second">Second Innings</MenuItem>
      </Select>

      <label style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
        Overs:
        <NumberSelector
          initial={overRange.start}
          min={0}
          max={Number.MAX_SAFE_INTEGER}
          onValid={(e) => {
            setOverRange({ ...overRange, start: e });
          }}
        />
        to
        <NumberSelector
          initial={overRange.end}
          min={0}
          max={Number.MAX_SAFE_INTEGER}
          onValid={(e) => {
            setOverRange({ ...overRange, end: e });
          }}
        />
      </label>

      <Button
        onClick={() => setMergeYears((prev) => !prev)}
        variant={mergeYears ? "contained" : "outlined"}
      >
        {mergeYears ? "Separate by Year" : "Merge Years"}
      </Button>
    </>
  );
}